module.exports = __webpack_public_path__ + "img/ico_component_menu.7c076bb5.svg";